import { Component, OnInit } from '@angular/core';
import { BlogTreeService } from '../services/blog-tree.service';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit {
  constructor() {}

  public ngOnInit() {}
}
